import { getDistance } from 'geolib';
import _ from 'lodash';
import { createInitials } from '../../common/dataAdjust';
import { _markerTypes, baseMarkers } from '../../components/map/BaseMarker';
import { findLocations, geoCodeAddresses } from "../../components/map/mapHelper";
import { createRefPath_event } from '../../firestoreData/appData/appRefPaths';

// https://github.com/google-map-react/google-map-react/blob/master/API.md

export const googleMapInitialState = (init_state) => {
  const usaCenter = {
    lat: 39.828175,
    lng: -98.5795
  }
  return { ...init_state, usaCenter }
};

const rts = {
  handleOpen_infoWindow: 'handleOpen_infoWindow',
  handleClose_infoWindow: 'handleClose_infoWindow',
  handleGet_geoLocation: 'handleGet_geoLocation',
  handleGet_geoLocations: 'handleGet_geoLocations',
  handleSet_geoLocation: 'handleSet_geoLocation',
  handleSet_geoLocations: 'handleSet_geoLocations',
  handleGetAllPlaces: 'handleGetAllPlaces',
  handleGetBounds: 'handleGetBounds',
  handleGetPlaces: 'handleGetPlaces',
  handleGetService: 'handleGetService',
  handleMapListData: 'handleMapListData',
  handleSelectedPlace: 'handleSelectedPlace',
  handleSetAllPlaces: 'handleSetAllPlaces',
  handleSetMapReady: 'handleSetMapReady',
  handleSetPlaces: 'handleSetPlaces',
  handleSetSelectedMarker: 'handleSetSelectedMarker',
  handleSet_map: 'handleSet_map',
  handleGetMarkers_appUsers: 'handleGetMarkers_appUsers',
  handleGetMarkers_demo: 'handleGetMarkers_demo',
  handelAmmend_init: 'handelAmmend_init',
}

export const geoListTypes = {
  groupedList: 'groupedList',
  list: 'list',
  location: 'location'
}

const _markerProps = {
  dot: {
    backgroundColor: 'blue',
    color: 'white'
  },
  appUsers: {
    backgroundColor: 'yellow',
    color: 'black'
  },
  demo: {
    backgroundColor: '#4b93ff',
    color: 'white'
  },
}

export const googleMapReducer = (state, action) => {

  const { apiKey, additionalProp, showClosestItemOnly, getGviDeps, pathViews, viewItem, viewListData, mapLists, locationsOf, displayProps } = state

  const { handleSetPlaces, handleSetAllPlaces, handleGetPlaces, handleGetAllPlaces, handleSet_geoLocation, handleSet_geoLocations } = googleMapHandlers(action.dispatch)

  switch (action.type) {

    case rts.handelAmmend_init:
      return { ...state, ...action.init }

    case rts.handleSet_map:
      const { map, defaultToSatallite } = action
      map && map.setOptions({
        mapTypeControl: true,
        mapTypeId: defaultToSatallite ? 'satellite' : 'roadmap'
      });
      return { ...state, gmap: action.map, gmaps: action.maps }

    case rts.handleSetMapReady:
      const { mr } = action
      const { m, mp } = mr
      return { ...state, mapReady: action.mr ? true : false, map: m, mapProps: mp }

    case rts.handleGetService:
      const service = (state.gmaps && state.gmap && state.gmaps.places) ? new state.gmaps.places.PlacesService(state.gmap) : null
      if (service && (action.name || action.giftCards)) {
        if (action.giftCards) {
          handleGetAllPlaces(action.giftCards)
        }
        handleGetPlaces(action.name)
      }
      return { ...state, service }

    case rts.handleGet_geoLocation:
      if (action.itemData) { geoCodeAddresses(apiKey, null, action.itemData, handleSet_geoLocation) }
      return { ...state }

    case rts.handleGet_geoLocations:
      if (viewListData) { geoCodeAddresses(apiKey, action.listData, null, handleSet_geoLocations) }
      return { ...state }

    case rts.handleSet_geoLocation:
      console.log('handleSet_geoLocation', action)
      updateMapLocations(pathViews, viewItem, action.listData)
      const markeri = baseMarkers(action.itemData, _markerTypes.default_dot, _markerProps.dot)
      return { ...state, mapData: action.itemData[0], markers: markeri }

    case rts.handleSet_geoLocations:
      console.log('handleSet_geoLocations', action)
      updateMapLocations(pathViews, viewItem, action.listData)
      const markerz = baseMarkers(action.listData, _markerTypes.default_dot, _markerProps.dot)
      return { ...state, mapListData: action.listData, markers: markerz }

    case rts.handleMapListData:
      const { mld: mapListData, elemPropType } = ammendLocations({ getGviDeps, pathViews, viewListData, mapLists, locationsOf, displayProps })
      const markers = baseMarkers(mapListData, _markerTypes.default_dot, _markerProps.dot)
      return { ...state, ...action, mapListData, markers, elemPropType }

    case rts.handleSelectedPlace:
      return { ...state, selectedPlace: action.selectedPlace, markerInfo: getMarkerInfo(action.selectedPlace) }

    case rts.handleOpen_infoWindow:
      return { ...state, currentInfoWindow: action.info }

    case rts.handleClose_infoWindow:
      return { ...state, currentInfoWindow: null }

    case rts.handleGetAllPlaces:
      getAllPlaces(action.itemsToMap, state, handleSetAllPlaces)
      return { ...state }

    case rts.handleGetPlaces:
      getPlaces(action.name, state, handleSetPlaces)
      return { ...state }

    case rts.handleSetAllPlaces:
      const { groupedPlaces } = action
      getGroupedPlaces(state, action, groupedPlaces, additionalProp, showClosestItemOnly)
      const _places = getPlacesFromGroupedPlaces(groupedPlaces)
      return { ...state, places: _places, groupedPlaces }

    case rts.handleSetPlaces:
      return { ...state, places: action.places }

    case rts.handleSetSelectedMarker:
      return { ...state, selectedMarker: action.marker, markerInfo: getMarkerInfo(action.marker) }

    case rts.handleGetBounds:
      return { ...state, mapBounds: state.gmaps ? getBounds(state.gmaps, state.mapListData) : null }

    case rts.handleGetMarkers_appUsers:
      const markerData = []
      if (action.locations) {
        Object.keys(action.locations).forEach((lk, index) => {
          const location = action.locations[lk]
          markerData.push(getMarkerData(location, action.appUserUid))
        })
      }
      const _markers = baseMarkers(markerData, _markerTypes.dot, _markerProps.appUsers)
      return { ...state, appUserMarkers: _markers }

    case rts.handleGetMarkers_demo:
      const _markersDemo = getDemoMarkers(action.demoCoordinates)
      return { ...state, demoMarkers: _markersDemo }

    default:
      return { ...state }
  }
}

export const googleMapHandlers = (dispatch) => {
  return {
    handelAmmend_init: (init) => dispatch({ type: rts.handelAmmend_init, dispatch, init }),
    handleSet_map: (map, maps, defaultToSatallite) => dispatch({ type: rts.handleSet_map, dispatch, map, maps, defaultToSatallite }),
    handleOpen_infoWindow: (info) => dispatch({ type: rts.handleOpen_infoWindow, dispatch, info }),
    handleClose_infoWindow: () => dispatch({ type: rts.handleClose_infoWindow, dispatch }),
    handleGet_geoLocation: (itemData) => dispatch({ type: rts.handleGet_geoLocation, dispatch, itemData }),
    handleGet_geoLocations: (listData) => dispatch({ type: rts.handleGet_geoLocations, dispatch, listData }),
    handleSet_geoLocation: (itemData) => dispatch({ type: rts.handleSet_geoLocation, dispatch, itemData }),
    handleSet_geoLocations: (listData) => dispatch({ type: rts.handleSet_geoLocations, dispatch, listData }),
    handleGetAllPlaces: (itemsToMap) => dispatch({ type: rts.handleGetAllPlaces, dispatch, itemsToMap }),
    handleGetBounds: () => dispatch({ type: rts.handleGetBounds, dispatch }),
    handleGetPlaces: (name) => dispatch({ type: rts.handleGetPlaces, dispatch, name }),
    handleGetService: (name, giftCards) => dispatch({ type: rts.handleGetService, dispatch, name, giftCards }),
    handleMapListData: () => dispatch({ type: rts.handleMapListData, dispatch }),
    handleSelectedPlace: (selectedPlace) => dispatch({ type: rts.handleSelectedPlace, dispatch, selectedPlace }),
    handleSetMapReady: (mr) => dispatch({ type: rts.handleSetMapReady, dispatch, mr }),
    handleSetAllPlaces: (groupedPlaces, items) => dispatch({ type: rts.handleSetAllPlaces, dispatch, groupedPlaces, items }),
    handleSetPlaces: (places) => dispatch({ type: rts.handleSetPlaces, dispatch, places }),
    handleSetSelectedMarker: (marker) => dispatch({ type: rts.handleSetSelectedMarker, dispatch, marker }),
    handleGetMarkers_appUsers: (locations, mapListData, appUserUid) => dispatch({ type: rts.handleGetMarkers_appUsers, dispatch, locations, mapListData, appUserUid }),
    handleGetMarkers_demo: (demoCoordinates) => dispatch({ type: rts.handleGetMarkers_demo, dispatch, demoCoordinates }),
  }
}

const getGroupedPlaces = (state, action, groupedPlaces, additionalProp, showClosestItemOnly) => {
  Object.keys(groupedPlaces).forEach(gpKey => {
    const _groupedPlaces = []
    const groupedPlace = groupedPlaces[gpKey]
    const _item = _.find(action.items, { name: gpKey })
    if (_item && _item[additionalProp]) {
      groupedPlace.forEach(gp => {
        gp[additionalProp] = _item[additionalProp]
        gp.distanceFromMe = getDistance(state.appUserLocation, gp)
        _groupedPlaces.push(gp)
      })
    }
    if (showClosestItemOnly) {
      const minPlace = getClosestPlace(_groupedPlaces)
      groupedPlaces[gpKey] = minPlace ? [minPlace] : []
    }
  })
}

const getPlacesFromGroupedPlaces = (groupedPlaces) => {
  const _places = []
  Object.keys(groupedPlaces).forEach(gpKey => {
    const groupedPlace = groupedPlaces[gpKey]
    groupedPlace.forEach(gp => {
      _places.push(gp)
    })
  })
  return _places
}

const getMarkerInfo = (selectedMarker) => {

  const { mapPosition, geometry, name, vicinity } = selectedMarker ?? {}
  let _position;

  if (mapPosition && mapPosition.lat && mapPosition.lng) {
    _position = {
      lat: mapPosition.lat,
      lng: mapPosition.lng,
    }
  } else {
    const { location } = geometry ?? {}
    const { lat, lng } = location ?? {}
    if (lat && lng) {
      _position = {
        lat: lat(),
        lng: lng(),
      }
    }
  }
  return { position: _position, name, vicinity }
}

const getClosestPlace = (places) => {
  let minDistance = 100000
  let minPlace;
  places.forEach(place => {
    if (place.distanceFromMe < minDistance) {
      minPlace = place
      minDistance = place.distanceFromMe
    }
  })
  return minPlace
}

const getAllPlaces = (itemsToMap, state, callback) => {

  const groupedPlaces = {}

  const cb = (places, name, index) => {
    groupedPlaces[name] = places
    if (Object.keys(itemsToMap).length === Object.keys(groupedPlaces).length) {
      callback(groupedPlaces, itemsToMap)
    }
  }

  if (itemsToMap) {
    const names = []
    Object.keys(itemsToMap).forEach(key => {
      names.push(itemsToMap[key].name)
    })

    names.forEach((name, index) => {
      getPlaces(name, state, cb, index)
    })
  }
}

const getPlaces = (name, state, callback, index) => {

  const { gmaps, service, dMargin, appUserLocation } = state

  const cb = (results, status) => {
    if (status === gmaps.places.PlacesServiceStatus.OK) {
      const _places = []
      for (var i = 0; i < results.length; i++) {
        var place = results[i];
        _places.push(place)
      }
      _places.forEach(place => {
        place.latitude = place.geometry.location.lat()
        place.longitude = place.geometry.location.lng()
      })
      callback(_places, name, index)
    } else {
      callback([], name, index)
    }
  }

  if (gmaps && service && appUserLocation) {
    const latLng = new gmaps.LatLng(appUserLocation.latitude, appUserLocation.longitude);
    const request = {
      location: latLng,
      // bounds: c.bounds,
      radius: dMargin,
      keyword: [name]
    }
    service.nearbySearch(request, cb);
  }
}

const ammendLocations = (props) => {

  const { getGviDeps, pathViews, viewListData, mapLists, locationsOf, displayProps } = props

  const { props_viewItem } = displayProps ?? {}

  let elemPropType = null

  const listOfProps = _.filter(props_viewItem, 'listOf')

  if (listOfProps && listOfProps.length === 1) {
    const listOfProp = listOfProps[0]
    findLocations(viewListData, mapLists, listOfProp)
  }

  if (viewListData) {
    Object.keys(viewListData).forEach((key, index) => {
      if (viewListData[key].googleMaps) {
        const gm = viewListData[key].googleMaps
        var regex = new RegExp('@(.*),(.*),');
        var lon_lat_match = gm.match(regex);
        var lat = lon_lat_match[1];
        var lng = lon_lat_match[2];
        viewListData[key].mapPosition = {
          lat: parseFloat(lat),
          lng: parseFloat(lng),
        }
      }
    })
  }

  let mld = _.filter(viewListData, 'mapPosition')

  if (locationsOf) {
    let locationsOfProp = _.find(Object.values(props_viewItem), function (o) { return o['prop'] === 'locationsOf'; })
    if (locationsOfProp) { elemPropType = locationsOfProp.elemPropType }
    let locationListsData = []
    locationsOf.forEach(location => {
      const deps = getGviDeps(location)
      const locationListData = this.props.fsGetRawData(location, pathViews, deps)
      if (locationListData) {
        locationListsData = [...locationListsData, ...locationListData]
      } else {

      }
    })
    mld = locationListsData
  }

  if (mld) { mld = _.sortBy(mld, 'name') }

  return { mld, elemPropType }
}

const getBounds = (gmaps, mapListData) => {

  const _bounds = new gmaps.LatLngBounds();

  if (mapListData) {
    mapListData.forEach(itemData => {
      if (itemData.mapPosition) {
        const { lat, lng } = itemData.mapPosition
        if (lat && lng) {
          _bounds.extend(itemData.mapPosition);
        }
      }
    })
  }

  const center = _bounds.getCenter()

  return {
    bounds: _bounds,
    initialCenter: {
      lat: center.lat(),
      lng: center.lng()
    }
  }
}

const getMarkerData = (location, appUserUid) => {
  const { appUserLocation, _itemKey, displayName } = location ? location : {}
  const _initials = displayName ? createInitials(displayName) : null
  const isAppUser = _itemKey === appUserUid
  const _markerData = {
    title: displayName,
    id: _itemKey,
    labelText: _initials,
    mapPosition: {
      lat: parseFloat(appUserLocation.latitude),
      lng: parseFloat(appUserLocation.longitude)
    },
    isAppUser: isAppUser,
  }
  return _markerData
}

const getDemoMarkers = (demoCoordinates) => {
  const getDemo = (dc, name, index) => {
    const _dc = dc ? dc.split(',') : null
    if (_dc && _dc.length === 2) {
      return {
        title: name,
        id: index,
        labelText: index.toString(),
        mapPosition: {
          lat: parseFloat(_dc[0]),
          lng: parseFloat(_dc[1]),
        },
      }
    }
  }

  const markerData = []
  demoCoordinates.forEach((dc, index) => {
    const demo1 = getDemo(dc, 'Demo ' + (index + 1), (index + 1))
    markerData.push(demo1)
  })
  const _markers = baseMarkers(markerData, _markerTypes.dot, _markerProps.demo)
  return _markers
}

const getRadius = (gmaps) => {

  const _bounds = new gmaps.LatLngBounds();

  const center = _bounds.getCenter();
  const ne = _bounds.getNorthEast();

  // r = radius of the earth in statute miles
  const r = 3963.0;
  const db = 57.2958

  // Convert lat or lng from decimal degrees into radians (divide by 57.2958)
  const lat1 = center.lat() / db;
  const lon1 = center.lng() / db;
  const lat2 = ne.lat() / db;
  const lon2 = ne.lng() / db;

  // distance = circle radius from center to Northeast corner of bounds
  const dis = r * Math.acos(Math.sin(lat1) * Math.sin(lat2) +
    Math.cos(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1));

  return dis
}

const updateMapLocations = async (pathViews, viewItem, listData) => {
  const { key: key_viewItem } = viewItem ?? {}
  if (listData) {
    listData.forEach(async item => {
      const { mapPosition } = item
      if (mapPosition) {
        const _refPath = createRefPath_event(pathViews, [key_viewItem, item._itemKey])
        const _data = _.cloneDeep(item)
        delete _data.id
        delete _data._itemKey
        await database_fns.update_docc({
          refPath: _refPath,
          data: _data,
        })
      }
    })
  }
}